<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class=" fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-3xl px-2 py-2 bg-white dark:bg-zinc-950 h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <div>
                        <div class="mt-4 px-4">
                            <div class="flex justify-between">
                                <div class="flex items-center gap-4">
                                    <div class="flex flex-col">
                                        <label for="status" >Status</label>
                                        <select id="status" class="w-40" [(ngModel)]="event.status" [disabled]="isEdit" (change)="onSelectStatus($event)">
                                            <option value="">Select Status</option>
                                            <option value="onway">Onway</option>
                                            <option value="arrived">Arrived</option>
                                            <option value="in_progress">In Progress</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                        <div *ngIf="!event.status && submitted" class="error">
                                            <p class="mt-2 text-red-600 text-xs">
                                                Status is required
                                            </p>
                                        </div>
                                        <div *ngIf="event.status && isEventExist" class="error">
                                            <p class="mt-2 text-red-600 text-xs">
                                                This status already exists in events
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label for="time" >Time</label>
                                        <input id="time" type="text" [(ngModel)]="event.time" [owlDateTime]="dtPicker" [owlDateTimeTrigger]="dtPicker"
                                             />
                                        <owl-date-time #dtPicker></owl-date-time>
                                    </div>
                                    <button class="btn btn-secondary mt-6" (click)="onConfirmLocation()">
                                        Confirm Location
                                    </button>
                                </div>

                                <div class="flex gap-2">
                                    <!-- Close Button -->
                                    <button type="button" (click)="onCloseModal()"
                                        class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x-mark -->
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            <!-- Address Input Field -->
                            <div class="mt-2 mb-4">
                                <label for="address"
                                    class="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
                                    Current Address
                                </label>
                                <div class="relative">
                                    <input googlePlace id="address" type="text" [(ngModel)]="currentAddress"
                                        (input)="onAddressInputChange(currentAddress)"
                                        (onSelect)="onSelectAddress($event)"
                                        class="w-full px-3 py-2 pr-10 text-sm border border-zinc-300 dark:border-zinc-600 rounded-md bg-white dark:bg-zinc-800 text-zinc-900 dark:text-zinc-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Loading address..." [disabled]="isLoadingAddress">

                                    <!-- Loading spinner -->
                                    <div *ngIf="isLoadingAddress"
                                        class="absolute inset-y-0 right-0 flex items-center pr-3">
                                        <svg class="animate-spin h-4 w-4 text-zinc-400"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                            </path>
                                        </svg>
                                    </div>
                                </div>

                                <!-- Coordinates Display -->
                                <p class="text-xs text-zinc-500 dark:text-zinc-400 mt-1">
                                    Coordinates: {{event.latitude | number:'1.6-6'}}, {{event.longitude |
                                    number:'1.6-6'}}
                                </p>
                            </div>

                            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

                            <section class="aspect-[4/3] w-full h-[90vh] map-section relative">
                                <google-map #map class="h-full w-full" [center]="mapCenter" [zoom]="18" [options]="mapOptions">
                                </google-map>
                                <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                                    <svg class="w-10 h-10 text-red-600 drop-shadow-lg" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zM12 11.5c-1.38 
                                                                       0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 
                                                                       2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                    </svg>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>